import {useContext} from 'react';

import {HoneepotContext} from '@/modules/common/context/Honeepot/HoneepotContext';

export const useHoneepot = () => {
  const context = useContext(HoneepotContext);

  if (context === null) {
    throw new Error('useHoneepot() must be used within a <HoneepotProvider>');
  }

  return context;
};
